type ForcedUpdate = { pageUrl: string } | null;

let snapshot: ForcedUpdate = null;
const listeners = new Set<() => void>();

export function getForcedUpdate(): ForcedUpdate {
  return snapshot;
}

export function showForcedUpdate(pageUrl: string): void {
  snapshot = { pageUrl };
  listeners.forEach(listener => listener());
}

export function subscribeForcedUpdate(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function resetForcedUpdate(): void {
  snapshot = null;
}
